import { createSelector } from '../reselect';
import { chartSales, totalSales } from '../generalSelectors';
import {
  total,
  simpleChart,
  getNewStatsService,
  simpleChartPlus,
  simpleChart2,
  simpleChartMinus,
  safeDivide,
  simpleChart4,
  simpleChart3,
} from '../generalUtils';

//
const totalAmazonSalesAFN = createSelector([getNewStatsService('amazon')], (stats) =>
  total(stats, 'AFN_sales')
);
const totalAmazonSalesMFN = createSelector([getNewStatsService('amazon')], (stats) =>
  total(stats, 'MFN_sales')
);

export const totalAmazonSales = createSelector(
  [totalAmazonSalesAFN, totalAmazonSalesMFN],
  (totalAmazonSalesAFN, totalAmazonSalesMFN) => {
    return totalAmazonSalesAFN + totalAmazonSalesMFN;
  }
);

const totalCanceledAmazonSalesAFN = createSelector([getNewStatsService('amazon')], (stats) =>
  total(stats, 'AFN_sales_canceled')
);
const totalCanceledAmazonSalesMFN = createSelector([getNewStatsService('amazon')], (stats) =>
  total(stats, 'MFN_sales_canceled')
);
const totalCanceledAmazonSales = createSelector(
  [totalCanceledAmazonSalesAFN, totalCanceledAmazonSalesMFN],
  (totalCanceledAmazonSalesAFN, totalCanceledAmazonSalesMFN) => {
    return totalCanceledAmazonSalesAFN + totalCanceledAmazonSalesMFN;
  }
);

const totalAmazonProductItemPriceAFN = createSelector([getNewStatsService('amazon')], (stats) =>
  total(stats, 'AFN_totalItemPriceAll')
);
const totalAmazonProductItemPriceMFN = createSelector([getNewStatsService('amazon')], (stats) =>
  total(stats, 'MFN_totalItemPriceAll')
);
const totalAmazonProductItemPrice = createSelector(
  [totalAmazonProductItemPriceAFN, totalAmazonProductItemPriceMFN],
  (totalAmazonProductItemPriceAFN, totalAmazonProductItemPriceMFN) => {
    return totalAmazonProductItemPriceAFN + totalAmazonProductItemPriceMFN;
  }
);

const totalCanceledAmazonProductItemPriceAFN = createSelector(
  [getNewStatsService('amazon')],
  (stats) => total(stats, 'AFN_totalItemPriceAll_canceled')
);
const totalCanceledAmazonProductItemPriceMFN = createSelector(
  [getNewStatsService('amazon')],
  (stats) => total(stats, 'MFN_totalItemPriceAll_canceled')
);
const totalCanceledAmazonProductItemPrice = createSelector(
  [totalCanceledAmazonProductItemPriceAFN, totalCanceledAmazonProductItemPriceMFN],
  (totalCanceledAmazonProductItemPriceAFN, totalCanceledAmazonProductItemPriceMFN) => {
    return totalCanceledAmazonProductItemPriceAFN + totalCanceledAmazonProductItemPriceMFN;
  }
);

const totalAmazonItemTaxAFN = createSelector([getNewStatsService('amazon')], (stats) =>
  total(stats, 'AFN_totalItemTax')
);
const totalAmazonItemTaxMFN = createSelector([getNewStatsService('amazon')], (stats) =>
  total(stats, 'MFN_totalItemTax')
);
const totalAmazonShippingTaxAFN = createSelector([getNewStatsService('amazon')], (stats) =>
  total(stats, 'AFN_totalShippingTax')
);
const totalAmazonShippingTaxMFN = createSelector([getNewStatsService('amazon')], (stats) =>
  total(stats, 'MFN_totalShippingTax')
);
const totalAmazonSalesTaxesAFN = createSelector(
  [totalAmazonItemTaxAFN, totalAmazonShippingTaxAFN],
  (totalAmazonItemTaxAFN, totalAmazonShippingTaxAFN) => {
    const res = totalAmazonItemTaxAFN + totalAmazonShippingTaxAFN;
    return res;
  }
);
const totalAmazonSalesTaxesMFN = createSelector(
  [totalAmazonItemTaxMFN, totalAmazonShippingTaxMFN],
  (totalAmazonItemTaxMFN, totalAmazonShippingTaxMFN) => {
    const res = totalAmazonItemTaxMFN + totalAmazonShippingTaxMFN;
    return res;
  }
);
const totalAmazonSalesTaxes = createSelector(
  [totalAmazonSalesTaxesAFN, totalAmazonSalesTaxesMFN],
  (totalAmazonSalesTaxesAFN, totalAmazonSalesTaxesMFN) => {
    return totalAmazonSalesTaxesAFN + totalAmazonSalesTaxesMFN;
  }
);

const totalCanceledAmazonItemTaxAFN = createSelector([getNewStatsService('amazon')], (stats) =>
  total(stats, 'AFN_totalItemTax_canceled')
);
const totalCanceledAmazonItemTaxMFN = createSelector([getNewStatsService('amazon')], (stats) =>
  total(stats, 'MFN_totalItemTax_canceled')
);
const totalCanceledAmazonShippingTaxAFN = createSelector([getNewStatsService('amazon')], (stats) =>
  total(stats, 'AFN_totalShippingTax_canceled')
);
const totalCanceledAmazonShippingTaxMFN = createSelector([getNewStatsService('amazon')], (stats) =>
  total(stats, 'MFN_totalShippingTax_canceled')
);

const totalCanceledAmazonSalesTaxesAFN = createSelector(
  [totalCanceledAmazonItemTaxAFN, totalCanceledAmazonShippingTaxAFN],
  (totalCanceledAmazonItemTaxAFN, totalCanceledAmazonShippingTaxAFN) =>
    totalCanceledAmazonItemTaxAFN + totalCanceledAmazonShippingTaxAFN
);
const totalCanceledAmazonSalesTaxesMFN = createSelector(
  [totalCanceledAmazonItemTaxMFN, totalCanceledAmazonShippingTaxMFN],
  (totalCanceledAmazonItemTaxMFN, totalCanceledAmazonShippingTaxMFN) =>
    totalCanceledAmazonItemTaxMFN + totalCanceledAmazonShippingTaxMFN
);
const totalCanceledAmazonSalesTaxes = createSelector(
  [totalCanceledAmazonSalesTaxesAFN, totalCanceledAmazonSalesTaxesMFN],
  (totalCanceledAmazonSalesTaxesAFN, totalCanceledAmazonSalesTaxesMFN) =>
    totalCanceledAmazonSalesTaxesAFN + totalCanceledAmazonSalesTaxesMFN
);

const totalAmazonPromotionDiscount = createSelector([getNewStatsService('amazon')], (stats) => {
  return total(stats, 'AFN_totalPromotionDiscount');
});
const totalAmazonPromotionDiscountTax = (stats) => total(stats, 'AFN_totalPromotionDiscountTax');
const totalAmazonShippingDiscountAFN = createSelector([getNewStatsService('amazon')], (stats) => {
  return total(stats, 'AFN_totalShippingDiscount');
});
const totalAmazonShippingDiscountMFN = createSelector([getNewStatsService('amazon')], (stats) => {
  return total(stats, 'MFN_totalShippingDiscount');
});
const totalAmazonShippingDiscount = createSelector(
  [totalAmazonShippingDiscountAFN, totalAmazonShippingDiscountMFN],
  (totalAmazonShippingDiscountAFN, totalAmazonShippingDiscountMFN) => {
    return totalAmazonShippingDiscountAFN + totalAmazonShippingDiscountMFN;
  }
);
const totalAmazonShippingDiscountTax = (stats) => total(stats, 'AFN_totalShippingDiscountTax');

const totalAmazonShippingPriceAFN = createSelector([getNewStatsService('amazon')], (stats) => {
  return total(stats, 'AFN_totalShippingPrice');
});
const totalAmazonShippingPriceMFN = createSelector([getNewStatsService('amazon')], (stats) => {
  return total(stats, 'MFN_totalShippingPrice');
});
const totalAmazonShippingPrice = createSelector(
  [totalAmazonShippingPriceAFN, totalAmazonShippingPriceMFN],
  (totalAmazonShippingPriceAFN, totalAmazonShippingPriceMFN) => {
    return totalAmazonShippingPriceAFN + totalAmazonShippingPriceMFN;
  }
);

const totalAmazonOrdersAFN = createSelector([getNewStatsService('amazon')], (stats) => {
  return total(stats, 'AFN_count');
});
const totalAmazonOrdersMFN = createSelector([getNewStatsService('amazon')], (stats) => {
  return total(stats, 'MFN_count');
});
const totalAmazonOrders = createSelector(
  [totalAmazonOrdersAFN, totalAmazonOrdersMFN],
  (totalAmazonOrdersAFN, totalAmazonOrdersMFN) => {
    return totalAmazonOrdersAFN + totalAmazonOrdersMFN;
  }
);

const totalCanceledAmazonOrdersAFN = createSelector([getNewStatsService('amazon')], (stats) =>
  total(stats, 'AFN_count_canceled')
);
const totalCanceledAmazonOrdersMFN = createSelector([getNewStatsService('amazon')], (stats) =>
  total(stats, 'MFN_count_canceled')
);
const totalCanceledAmazonOrders = createSelector(
  [totalCanceledAmazonOrdersAFN, totalCanceledAmazonOrdersMFN],
  (totalCanceledAmazonOrdersAFN, totalCanceledAmazonOrdersMFN) =>
    totalCanceledAmazonOrdersAFN + totalCanceledAmazonOrdersMFN
);

const totalAmazonItemsAFN = createSelector([getNewStatsService('amazon')], (stats) => {
  return total(stats, 'AFN_items');
});
const totalAmazonItemsMFN = createSelector([getNewStatsService('amazon')], (stats) => {
  return total(stats, 'MFN_items');
});
const totalAmazonItems = createSelector(
  [totalAmazonItemsAFN, totalAmazonItemsMFN],
  (totalAmazonItemsAFN, totalAmazonItemsMFN) => {
    return totalAmazonItemsAFN + totalAmazonItemsMFN;
  }
);
const totalCanceledAmazonItemsAFN = createSelector([getNewStatsService('amazon')], (stats) => {
  return total(stats, 'AFN_items_canceled');
});
const totalCanceledAmazonItemsMFN = createSelector([getNewStatsService('amazon')], (stats) => {
  return total(stats, 'MFN_items_canceled');
});
const totalCanceledAmazonItems = createSelector(
  [totalCanceledAmazonItemsAFN, totalCanceledAmazonItemsMFN],
  (totalCanceledAmazonItemsAFN, totalCanceledAmazonItemsMFN) => {
    return totalCanceledAmazonItemsAFN + totalCanceledAmazonItemsMFN;
  }
);
const totalAmazonFeesAFN = createSelector([getNewStatsService('amazon')], (stats) => {
  return total(stats, 'AFN_fees');
});
const totalAmazonFeesMFN = createSelector([getNewStatsService('amazon')], (stats) => {
  return total(stats, 'MFN_fees');
});
const totalAmazonFees = createSelector(
  [totalAmazonFeesAFN, totalAmazonFeesMFN],
  (totalAmazonFeesAFN, totalAmazonFeesMFN) => {
    return totalAmazonFeesAFN + totalAmazonFeesMFN;
  }
);
const totalCanceledAmazonFeesAFN = createSelector([getNewStatsService('amazon')], (stats) => {
  return total(stats, 'AFN_fees_canceled');
});
const totalCanceledAmazonFeesMFN = createSelector([getNewStatsService('amazon')], (stats) => {
  return total(stats, 'MFN_fees_canceled');
});
const totalCanceledAmazonFees = createSelector(
  [totalCanceledAmazonFeesAFN, totalCanceledAmazonFeesMFN],
  (totalCanceledAmazonFeesAFN, totalCanceledAmazonFeesMFN) => {
    return totalCanceledAmazonFeesAFN + totalCanceledAmazonFeesMFN;
  }
);

// amazon-ads
const amazonAdsConversionValue = createSelector([getNewStatsService('amazon')], (stats) => {
  return total(stats, 'conversionValue');
});
const amazonAds = createSelector([getNewStatsService('amazon')], (stats) => {
  return total(stats, 'spend');
});
const amazonClicks = createSelector([getNewStatsService('amazon')], (stats) => {
  return total(stats, 'clicks');
});
const amazonAdsTotalImpressions = createSelector([getNewStatsService('amazon')], (stats) => {
  return total(stats, 'impressions');
});

const amazonROAS = createSelector(
  [amazonAdsConversionValue, amazonAds],
  (amazonAdsConversionValue, amazonAds) => {
    return amazonAdsConversionValue / amazonAds;
  }
);

const amazonCPC = createSelector([amazonAds, amazonClicks], (amazonAdsTotalCost, amazonClicks) => {
  return amazonAdsTotalCost / amazonClicks;
});
const amazonPurchases = createSelector([getNewStatsService('amazon')], (stats) => {
  return total(stats, 'purchases');
});
const amazonTACos = createSelector(
  [totalAmazonProductItemPrice, amazonAds],
  (totalAmazonProductItemPrice, amazonAdsTotalCost) => {
    return (amazonAdsTotalCost / totalAmazonProductItemPrice) * 100;
  }
);

// amazon-ads charts
const chartAmazonAds = createSelector([getNewStatsService('amazon')], (stats) => {
  return simpleChart(stats, 'spend');
});

const amazonConversionValueChart = createSelector([getNewStatsService('amazon')], (stats) => {
  return simpleChart(stats, 'conversionValue');
});

const amazonRoasChart = createSelector(
  [amazonConversionValueChart, chartAmazonAds],
  (conversionValue, amazonAds) => simpleChart2(conversionValue, amazonAds)
);
const chartAmazonClicks = createSelector([getNewStatsService('amazon')], (stats) => {
  return simpleChart(stats, 'clicks');
});
const chartAmazonCPC = createSelector(
  [amazonConversionValueChart, chartAmazonClicks],
  (conValue, clicks) => {
    return simpleChart2(conValue, clicks);
  }
);
const chartAmazonPurchases = createSelector([getNewStatsService('amazon')], (stats) => {
  return simpleChart(stats, 'purchases');
});
// const chartAmazonTACos = createSelector([totalAmazonSales,amazonAdsTotalCost], (stats) => {

//   return simpleChart(stats, 'amazonTACos');
// });

// charts
const chartAmazonSalesAFN = createSelector([getNewStatsService('amazon')], (stats) => {
  return simpleChart(stats, 'AFN_sales');
});
const chartAmazonSalesMFN = createSelector([getNewStatsService('amazon')], (stats) => {
  return simpleChart(stats, 'MFN_sales');
});
export const chartAmazonSales = createSelector(
  [chartAmazonSalesAFN, chartAmazonSalesMFN],
  (chartAmazonSalesAFN, chartAmazonSalesMFN) => {
    return simpleChartPlus(chartAmazonSalesAFN, chartAmazonSalesMFN);
  }
);
const chartCanceledAmazonSalesAFN = createSelector([getNewStatsService('amazon')], (stats) => {
  return simpleChart(stats, 'AFN_sales_canceled');
});
const chartCanceledAmazonSalesMFN = createSelector([getNewStatsService('amazon')], (stats) => {
  return simpleChart(stats, 'MFN_sales_canceled');
});
const chartCanceledAmazonSales = createSelector(
  [chartCanceledAmazonSalesAFN, chartCanceledAmazonSalesMFN],
  (chartCanceledAmazonSalesAFN, chartCanceledAmazonSalesMFN) => {
    return simpleChartPlus(chartCanceledAmazonSalesAFN, chartCanceledAmazonSalesMFN);
  }
);
const chartAmazonProductItemPriceAFN = createSelector([getNewStatsService('amazon')], (stats) => {
  return simpleChart(stats, 'AFN_totalItemPriceAll');
});
const chartAmazonProductItemPriceMFN = createSelector([getNewStatsService('amazon')], (stats) => {
  return simpleChart(stats, 'MFN_totalItemPriceAll');
});
const chartAmazonProductItemPrice = createSelector(
  [chartAmazonProductItemPriceAFN, chartAmazonProductItemPriceMFN],
  (chartAmazonProductItemPriceAFN, chartAmazonProductItemPriceMFN) => {
    return simpleChartPlus(chartAmazonProductItemPriceAFN, chartAmazonProductItemPriceMFN);
  }
);
const chartCanceledAmazonProductItemPriceAFN = createSelector(
  [getNewStatsService('amazon')],
  (stats) => {
    return simpleChart(stats, 'AFN_totalItemPriceAll_canceled');
  }
);
const chartCanceledAmazonProductItemPriceMFN = createSelector(
  [getNewStatsService('amazon')],
  (stats) => {
    return simpleChart(stats, 'MFN_totalItemPriceAll_canceled');
  }
);
const chartCanceledAmazonProductItemPrice = createSelector(
  [chartCanceledAmazonProductItemPriceAFN, chartCanceledAmazonProductItemPriceMFN],
  (chartCanceledAmazonProductItemPriceAFN, chartCanceledAmazonProductItemPriceMFN) => {
    return simpleChartPlus(
      chartCanceledAmazonProductItemPriceAFN,
      chartCanceledAmazonProductItemPriceMFN
    );
  }
);
const chartAmazonOrdersAFN = createSelector([getNewStatsService('amazon')], (stats) => {
  return simpleChart(stats, 'AFN_count');
});
const chartAmazonOrdersMFN = createSelector([getNewStatsService('amazon')], (stats) => {
  return simpleChart(stats, 'MFN_count');
});
const chartAmazonOrders = createSelector(
  [chartAmazonOrdersAFN, chartAmazonOrdersMFN],
  (chartAmazonOrdersAFN, chartAmazonOrdersMFN) => {
    return simpleChartPlus(chartAmazonOrdersAFN, chartAmazonOrdersMFN);
  }
);
const chartCanceledAmazonOrdersAFN = createSelector([getNewStatsService('amazon')], (stats) => {
  return simpleChart(stats, 'AFN_count_canceled');
});
const chartCanceledAmazonOrdersMFN = createSelector([getNewStatsService('amazon')], (stats) => {
  return simpleChart(stats, 'MFN_count_canceled');
});
const chartCanceledAmazonOrders = createSelector(
  [chartCanceledAmazonOrdersAFN, chartCanceledAmazonOrdersMFN],
  (chartCanceledAmazonOrdersAFN, chartCanceledAmazonOrdersMFN) => {
    return simpleChartPlus(chartCanceledAmazonOrdersAFN, chartCanceledAmazonOrdersMFN);
  }
);

const chartAmazonItemsAFN = createSelector([getNewStatsService('amazon')], (stats) => {
  return simpleChart(stats, 'AFN_items');
});
const chartAmazonItemsMFN = createSelector([getNewStatsService('amazon')], (stats) => {
  return simpleChart(stats, 'MFN_items');
});
const chartAmazonItems = createSelector(
  [chartAmazonItemsAFN, chartAmazonItemsMFN],
  (chartAmazonItemsAFN, chartAmazonItemsMFN) => {
    return simpleChartPlus(chartAmazonItemsAFN, chartAmazonItemsMFN);
  }
);
const chartCanceledAmazonItemsAFN = createSelector([getNewStatsService('amazon')], (stats) => {
  return simpleChart(stats, 'AFN_items_canceled');
});
const chartCanceledAmazonItemsMFN = createSelector([getNewStatsService('amazon')], (stats) => {
  return simpleChart(stats, 'MFN_items_canceled');
});
const chartCanceledAmazonItems = createSelector(
  [chartCanceledAmazonItemsAFN, chartCanceledAmazonItemsMFN],
  (chartCanceledAmazonItemsAFN, chartCanceledAmazonItemsMFN) => {
    return simpleChartPlus(chartCanceledAmazonItemsAFN, chartCanceledAmazonItemsMFN);
  }
);
const chartAmazonFeesAFN = createSelector([getNewStatsService('amazon')], (stats) => {
  return simpleChart(stats, 'AFN_fees');
});
const chartAmazonFeesMFN = createSelector([getNewStatsService('amazon')], (stats) => {
  return simpleChart(stats, 'MFN_fees');
});
const chartAmazonFees = createSelector(
  [chartAmazonFeesAFN, chartAmazonFeesMFN],
  (chartAmazonFeesAFN, chartAmazonFeesMFN) => {
    return simpleChartPlus(chartAmazonFeesAFN, chartAmazonFeesMFN);
  }
);
const chartCanceledAmazonFeesAFN = createSelector([getNewStatsService('amazon')], (stats) => {
  return simpleChart(stats, 'AFN_fees_canceled');
});
const chartCanceledAmazonFeesMFN = createSelector([getNewStatsService('amazon')], (stats) => {
  return simpleChart(stats, 'MFN_fees_canceled');
});
const chartCanceledAmazonFees = createSelector(
  [chartCanceledAmazonFeesAFN, chartCanceledAmazonFeesMFN],
  (chartCanceledAmazonFeesAFN, chartCanceledAmazonFeesMFN) => {
    return simpleChartPlus(chartCanceledAmazonFeesAFN, chartCanceledAmazonFeesMFN);
  }
);

const chartTotalItemTaxAFN = createSelector([getNewStatsService('amazon')], (stats) => {
  return simpleChart(stats, 'AFN_totalItemTax');
});
const chartTotalShippingTaxAFN = createSelector([getNewStatsService('amazon')], (stats) => {
  return simpleChart(stats, 'AFN_totalShippingTax');
});
const chartTotalItemTaxMFN = createSelector([getNewStatsService('amazon')], (stats) => {
  return simpleChart(stats, 'MFN_totalItemTax');
});
const chartTotalShippingTaxMFN = createSelector([getNewStatsService('amazon')], (stats) => {
  return simpleChart(stats, 'MFN_totalShippingTax');
});

const chartAmazonSalesTaxesAFN = createSelector(
  [chartTotalItemTaxAFN, chartTotalShippingTaxAFN],
  (chartTotalItemTaxAFN, chartTotalShippingTaxAFN) => {
    return simpleChartPlus(chartTotalItemTaxAFN, chartTotalShippingTaxAFN);
  }
);
const chartAmazonSalesTaxesMFN = createSelector(
  [chartTotalItemTaxMFN, chartTotalShippingTaxMFN],
  (chartTotalItemTaxMFN, chartTotalShippingTaxMFN) => {
    return simpleChartPlus(chartTotalItemTaxMFN, chartTotalShippingTaxMFN);
  }
);
const chartAmazonSalesTaxes = createSelector(
  [chartAmazonSalesTaxesAFN, chartAmazonSalesTaxesMFN],
  (chartAmazonSalesTaxesAFN, chartAmazonSalesTaxesMFN) => {
    return simpleChartPlus(chartAmazonSalesTaxesAFN, chartAmazonSalesTaxesMFN);
  }
);
const chartCanceledTotalItemTaxAFN = createSelector([getNewStatsService('amazon')], (stats) => {
  return simpleChart(stats, 'AFN_totalItemTax_canceled');
});
const chartCanceledTotalShippingTaxAFN = createSelector([getNewStatsService('amazon')], (stats) => {
  return simpleChart(stats, 'AFN_totalShippingTax_canceled');
});
const chartCanceledTotalItemTaxMFN = createSelector([getNewStatsService('amazon')], (stats) => {
  return simpleChart(stats, 'MFN_totalItemTax_canceled');
});
const chartCanceledTotalShippingTaxMFN = createSelector([getNewStatsService('amazon')], (stats) => {
  return simpleChart(stats, 'MFN_totalShippingTax_canceled');
});

const chartCanceledAmazonSalesTaxesAFN = createSelector(
  [chartCanceledTotalItemTaxAFN, chartCanceledTotalShippingTaxAFN],
  (chartCanceledTotalItemTaxAFN, chartCanceledTotalShippingTaxAFN) => {
    return simpleChartPlus(chartCanceledTotalItemTaxAFN, chartCanceledTotalShippingTaxAFN);
  }
);
const chartCanceledAmazonSalesTaxesMFN = createSelector(
  [chartCanceledTotalItemTaxMFN, chartCanceledTotalShippingTaxMFN],
  (chartCanceledTotalItemTaxMFN, chartCanceledTotalShippingTaxMFN) => {
    return simpleChartPlus(chartCanceledTotalItemTaxMFN, chartCanceledTotalShippingTaxMFN);
  }
);
const chartCanceledAmazonSalesTaxes = createSelector(
  [chartCanceledAmazonSalesTaxesAFN, chartCanceledAmazonSalesTaxesMFN],
  (chartCanceledAmazonSalesTaxesAFN, chartCanceledAmazonSalesTaxesMFN) => {
    return simpleChartPlus(chartCanceledAmazonSalesTaxesAFN, chartCanceledAmazonSalesTaxesMFN);
  }
);

// amazonNetSales -  Gross sales (what we show for the sales in the amazon sales section) - shipping - taxes / discounts are already calculated in salesTotal
const amazonNetSales = createSelector(
  [
    totalAmazonProductItemPrice,
    totalAmazonShippingPrice,
    totalAmazonShippingDiscount,
    totalAmazonSalesTaxes,
  ],
  (
    totalAmazonProductItemPrice,
    totalAmazonShippingPrice,
    totalAmazonShippingDiscount,
    totalAmazonSalesTaxes
  ) => {
    return (
      totalAmazonProductItemPrice -
      totalAmazonShippingPrice +
      totalAmazonShippingDiscount -
      totalAmazonSalesTaxes
    );
  }
);

const chartAmazonNetSales = createSelector(
  [getNewStatsService('amazon'), chartAmazonProductItemPrice, chartAmazonSalesTaxes],
  (stats, chartAmazonProductItemPrice, chartAmazonSalesTaxes) => {
    const chartTotalShippingAFN = simpleChart(stats, 'AFN_totalShippingPrice');
    const chartTotalShippingMFN = simpleChart(stats, 'MFN_totalShippingPrice');
    const chartTotalShipping = simpleChartPlus(chartTotalShippingAFN, chartTotalShippingMFN);

    const chartTotalShippingDiscountAFN = simpleChart(stats, 'AFN_totalShippingDiscount');
    const chartTotalShippingDiscountMFN = simpleChart(stats, 'MFN_totalShippingDiscount');
    const chartTotalShippingDiscount = simpleChartPlus(
      chartTotalShippingDiscountAFN,
      chartTotalShippingDiscountMFN
    );

    const stage_1 = simpleChartMinus(chartAmazonProductItemPrice, chartTotalShipping);
    const stage_2 = simpleChartMinus(stage_1, chartAmazonSalesTaxes);
    const stage_3 = simpleChartPlus(stage_2, chartTotalShippingDiscount);
    return stage_3; // TODO: add shipping, taxes, discounts
  }
);

// amazonMER
const amazonMER = createSelector([amazonNetSales, amazonAds], (amazonNetSales, amazonAds) => {
  return safeDivide(100 * amazonAds, amazonNetSales); // TODO: (100 * partialValue) / totalValue
});

const amazonCogsAFN = createSelector([getNewStatsService('amazon')], (stats) => {
  return total(stats, 'AFN_costs');
});
const amazonCogsMFN = createSelector([getNewStatsService('amazon')], (stats) => {
  return total(stats, 'MFN_costs');
});
const amazonCogs = createSelector(
  [amazonCogsAFN, amazonCogsMFN],
  (amazonCogsAFN, amazonCogsMFN) => {
    return amazonCogsAFN + amazonCogsMFN;
  }
);

const amazonHandlingFeesAFN = createSelector([getNewStatsService('amazon')], (stats) => {
  return total(stats, 'AFN_handlingFees');
});
const amazonHandlingFeesMFN = createSelector([getNewStatsService('amazon')], (stats) => {
  return total(stats, 'MFN_handlingFees');
});
const amazonHandlingFees = createSelector(
  [amazonHandlingFeesAFN, amazonHandlingFeesMFN],
  (amazonHandlingFeesAFN, amazonHandlingFeesMFN) => {
    return amazonHandlingFeesAFN + amazonHandlingFeesMFN;
  }
);

const amazonMERChart = createSelector(
  [chartAmazonNetSales, chartAmazonAds],
  (chartAmazonNetSales, chartAmazonAds) => {
    return simpleChart2(chartAmazonAds, chartAmazonNetSales, { chart1yMultiplier: 100 }); // TODO: (100 * partialValue) / totalValue
  }
);

// amazonAOV
const amazonAOV = createSelector(
  [totalAmazonProductItemPrice, totalAmazonOrders],
  (totalAmazonProductItemPrice, totalAmazonOrders) => {
    return safeDivide(totalAmazonProductItemPrice, totalAmazonOrders); // TODO:
  }
);
const amazonAOVChart = createSelector(
  [chartAmazonProductItemPrice, chartAmazonPurchases],
  (chartAmazonProductItemPrice, chartAmazonPurchases) => {
    return simpleChart2(chartAmazonProductItemPrice, chartAmazonPurchases); // TODO:
  }
);

// amazonCPA
const amazonCPA = createSelector([amazonAds, totalAmazonOrders], (amazonAds, totalAmazonOrders) => {
  return safeDivide(amazonAds, totalAmazonOrders);
});
const amazonCPAChart = createSelector(
  [chartAmazonAds, chartAmazonOrders],
  (chartAmazonAds, chartAmazonOrders) => {
    return simpleChart2(chartAmazonAds, chartAmazonOrders);
  }
);

// amazonExpenses
const amazonExpenses = createSelector(
  [totalAmazonFees, amazonAds, amazonCogs, amazonHandlingFees],
  (totalAmazonFees, amazonAds, amazonCogs, amazonHandlingFees) => {
    return totalAmazonFees + amazonAds + amazonCogs + amazonHandlingFees;
  }
);

const amazonExpensesChart = createSelector(
  [getNewStatsService('amazon'), chartAmazonFees, chartAmazonAds],
  (stats, chartAmazonFees, chartAmazonAds) => {
    const chartAmazonCogsAFN = simpleChart(stats, 'AFN_costs');
    const chartAmazonCogsMFM = simpleChart(stats, 'MFN_costs');
    const chartAmazonCogs = simpleChartPlus(chartAmazonCogsAFN, chartAmazonCogsMFM);

    const chartAmazonHandlingFeesAFN = simpleChart(stats, 'AFN_handlingFees');
    const chartAmazonHandlingFeesMFM = simpleChart(stats, 'MFN_handlingFees');
    const chartAmazonHandlingFees = simpleChartPlus(
      chartAmazonHandlingFeesAFN,
      chartAmazonHandlingFeesMFM
    );
    return simpleChart3(chartAmazonAds, chartAmazonFees, [
      chartAmazonCogs,
      chartAmazonHandlingFees,
    ]);
  }
);

const amazonNetProfit = createSelector(
  [amazonNetSales, amazonExpenses],
  (amazonNetSales, amazonExpenses) => {
    return amazonNetSales - amazonExpenses;
  }
);
const cahrtAmazonNetProfit = createSelector(
  [chartAmazonNetSales, amazonExpensesChart],
  (chartAmazonNetSales, amazonExpensesChart) => {
 
    return simpleChartMinus(chartAmazonNetSales, amazonExpensesChart);
  }
);

const blendedSales = createSelector(
  [totalSales, totalAmazonProductItemPrice],
  (totalSales, totalAmazonProductItemPrice) => {
    return totalSales + totalAmazonProductItemPrice;
  }
);

const chartBlendedSales = createSelector(
  [chartSales, chartAmazonProductItemPrice],
  (chartSales, chartAmazonProductItemPrice) =>
    simpleChartPlus(chartSales, chartAmazonProductItemPrice)
);

// MAINLY FOR updateDayStats
const PROPS_TO_SELECTORS = {};

export default {
  PROPS_TO_SELECTORS,
  SELECTORS: {
    totalAmazonPromotionDiscount,
    totalAmazonShippingPrice,
    totalAmazonSales,
    chartAmazonSales,
    totalAmazonProductItemPrice,
    chartAmazonProductItemPrice,
    totalAmazonSalesTaxes,
    chartAmazonSalesTaxes,
    totalAmazonOrders,
    chartAmazonOrders,
    totalAmazonItems,
    chartAmazonItems,
    totalAmazonFees,
    chartAmazonFees,
    totalAmazonSalesAFN,
    chartAmazonSalesAFN,
    totalAmazonSalesMFN,
    chartAmazonSalesMFN,
    totalAmazonProductItemPriceAFN,
    chartAmazonProductItemPriceAFN,
    totalAmazonProductItemPriceMFN,
    chartAmazonProductItemPriceMFN,
    totalAmazonSalesTaxesAFN,
    chartAmazonSalesTaxesAFN,
    totalAmazonSalesTaxesMFN,
    chartAmazonSalesTaxesMFN,
    totalAmazonOrdersAFN,
    chartAmazonOrdersAFN,
    totalAmazonOrdersMFN,
    chartAmazonOrdersMFN,
    totalAmazonItemsAFN,
    chartAmazonItemsAFN,
    totalAmazonItemsMFN,
    chartAmazonItemsMFN,
    totalAmazonFeesAFN,
    chartAmazonFeesAFN,
    totalAmazonFeesMFN,
    chartAmazonFeesMFN,

    totalCanceledAmazonSales,
    chartCanceledAmazonSales,
    totalCanceledAmazonProductItemPrice,
    chartCanceledAmazonProductItemPrice,
    totalCanceledAmazonSalesTaxes,
    chartCanceledAmazonSalesTaxes,
    totalCanceledAmazonOrders,
    chartCanceledAmazonOrders,
    totalCanceledAmazonItems,
    chartCanceledAmazonItems,
    totalCanceledAmazonFees,
    chartCanceledAmazonFees,
    totalCanceledAmazonSalesAFN,
    chartCanceledAmazonSalesAFN,
    totalCanceledAmazonSalesMFN,
    chartCanceledAmazonSalesMFN,
    totalCanceledAmazonProductItemPriceAFN,
    chartCanceledAmazonProductItemPriceAFN,
    totalCanceledAmazonProductItemPriceMFN,
    chartCanceledAmazonProductItemPriceMFN,
    totalCanceledAmazonSalesTaxesAFN,
    chartCanceledAmazonSalesTaxesAFN,
    totalCanceledAmazonSalesTaxesMFN,
    chartCanceledAmazonSalesTaxesMFN,
    totalCanceledAmazonOrdersAFN,
    chartCanceledAmazonOrdersAFN,
    totalCanceledAmazonOrdersMFN,
    chartCanceledAmazonOrdersMFN,
    totalCanceledAmazonItemsAFN,
    chartCanceledAmazonItemsAFN,
    totalCanceledAmazonItemsMFN,
    chartCanceledAmazonItemsMFN,
    totalCanceledAmazonFeesAFN,
    chartCanceledAmazonFeesAFN,
    totalCanceledAmazonFeesMFN,
    chartCanceledAmazonFeesMFN,

    amazonTACos,
    // chartAmazonTACos,
    amazonPurchases,
    chartAmazonPurchases,
    amazonClicks,
    chartAmazonClicks,
    amazonCPC,
    chartAmazonCPC,
    amazonROAS,
    amazonRoasChart,
    amazonAds,
    chartAmazonAds,
    amazonAdsConversionValue,
    amazonConversionValueChart,

    amazonNetSales,
    chartAmazonNetSales,
    amazonNetProfit,
    cahrtAmazonNetProfit,
    amazonMER,
    amazonMERChart,
    amazonAOV,
    amazonAOVChart,
    amazonCPA,
    amazonCPAChart,
    amazonExpenses,
    amazonExpensesChart,

    blendedSales,
    chartBlendedSales,

    amazonCogs,
    amazonHandlingFees,
    totalAmazonShippingDiscount,

    // chartAmazonItemPrice,
    // totalAmazonOrders,
    // chartAmazonOrders,
    // totalAmazonItems,
    // chartAmazonItems,
  },
};
